enum SubscriptionPauseUnusedPeriodType {
    CALCULATE_AUTOMATICALLY = 'CALCULATE_AUTOMATICALLY',
    CUSTOM = 'CUSTOM',
}

export default SubscriptionPauseUnusedPeriodType;
